import { Box } from '@mui/material';

import { HomepageRedirect } from '@/features/UserConfig/HomepageRedirect';
import Loader from '@/shared/ui/feedback/Spinner';

import { useTokenAuth } from './useTokenAuth';

export const TokenAuth = () => {
  const { isReady } = useTokenAuth();

  if (isReady) {
    return <HomepageRedirect />;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: '100vh'
      }}
    >
      <Loader />
    </Box>
  );
};
